import Promise from 'bluebird';
import focusInterval from 'focus-interval';

export const UPDATE_AUTHENTICATED = 'UPDATE_AUTHENTICATED';
export const GET_ACCOUNT_SUCCESS = 'GET_ACCOUNT_SUCCESS';
export const GET_TOKEN_SUCCESS = 'GET_TOKEN_SUCCESS';
export const UPDATE_USER_CLIENT_ID = 'UPDATE_USER_CLIENT_ID';

const GET_ACCOUNT_ERROR = 'GET_ACCOUNT_ERROR';
export const GET_TOKEN_BEGIN = 'GET_TOKEN_BEGIN';
const GET_TOKEN_ERROR = 'GET_TOKEN_ERROR';

import createApiClient from 'seek-jobs-api-client';
const api = createApiClient();

const initialState = {
  authenticated: false,
  displayName: '',
  token: '',
  ready: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case UPDATE_AUTHENTICATED:
      const { authenticated } = action.payload;

      return {
        ...state,
        authenticated,
        ready: !authenticated
      };

    case GET_ACCOUNT_SUCCESS:
      const { emailAddress, personalDetails, emailCorrelationId } = action.payload;
      const { firstName } = personalDetails;

      const displayName = firstName || emailAddress.split('@')[0];

      return {
        ...state,
        displayName,
        emailCorrelationId,
        ready: true
      };

    case GET_ACCOUNT_ERROR:
      return {
        ...state,
        displayName: '',
        ready: true
      };

    case GET_TOKEN_BEGIN:
      return {
        ...state,
        token: ''
      };

    case UPDATE_USER_CLIENT_ID:
      const { userClientId } = action.payload;

      return {
        ...state,
        userClientId
      };

    case GET_TOKEN_SUCCESS:
      const { token } = action.payload;

      return {
        ...state,
        token,
        authenticated: true
      };

    case GET_TOKEN_ERROR:
      return {
        ...state,
        token: '',
        authenticated: false
      };

    default:
      return state;
  }
}

export function updateAuthenticated(cookies) {
  const authenticated = api.authentication.isAuthenticated(cookies);

  return {
    type: UPDATE_AUTHENTICATED,
    payload: { authenticated }
  };
}

let clientTokenPromise;
const TOKEN_REFRESH_INTERVAL = 30 * 60 * 1000;
export const getClientToken = () => dispatch => {
  if (clientTokenPromise) {
    return clientTokenPromise;
  }

  const dispatchGetClientToken = () => {
    dispatch({ type: GET_TOKEN_BEGIN });

    clientTokenPromise = api.authentication.token()
      .then(token => {
        dispatch({
          type: GET_TOKEN_SUCCESS,
          payload: token,
          meta: { hotjar: 'Logged In' }
        });
      })
      .catch(err => {
        dispatch({ type: GET_TOKEN_ERROR });

        return Promise.reject(err);
      });

    return clientTokenPromise;
  };

  focusInterval(() => dispatchGetClientToken(), TOKEN_REFRESH_INTERVAL, window);

  return dispatchGetClientToken();
};

export const updateClientUserId = userClientId => ({
  type: UPDATE_USER_CLIENT_ID,
  payload: {
    userClientId
  }
});

export const getCandidateAccount = () => (dispatch, getState) => {
  const { token } = getState().user;

  return api.candidate.account(token)
    .then(account => {
      dispatch({
        type: GET_ACCOUNT_SUCCESS,
        payload: account
      });
    })
    .catch(error => {
      dispatch({
        type: GET_ACCOUNT_ERROR,
        error: true,
        payload: error
      });
    });
};

export const userTokenSelector = state => state.user.token;



/** WEBPACK FOOTER **
 ** ./app/store/user/user.js
 **/